import { Route } from 'react-router';
import React from 'react';
import routes from './routes';
import Restricted from '../components/auth/Restricted';

export const entityGroupRoutes = (ENTITY: string, rule: string, Components: any) => {
    const results: any = {};

    // @ts-ignore
    let key: any = routes[`${ENTITY}S_LIST`];
    if (Components.list) {
        results[`${ENTITY}S_LIST`] = (
            <Route
                exact
                key={key}
                path={key}
                render={() => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.list />
                    </Restricted>
                )}
            />
        );
    }

    // @ts-ignore
    if (Components.edit) {
        // @ts-ignore
        key = routes[`${ENTITY}_EDIT`];
        results[`${ENTITY}_EDIT`] = (
            <Route
                exact
                key={key}
                path={key}
                render={(props) => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.edit {...props} />
                    </Restricted>
                )}
            />
        );
    }
    if (Components.create) {
        // @ts-ignore
        key = routes[`${ENTITY}_CREATE`];

        if (ENTITY == 'INCENTIVE') {
            console.log('key', key);
        }

        results[`${ENTITY}_CREATE`] = (
            <Route
                exact
                key={key}
                path={key}
                render={(props) => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.create {...props} />
                    </Restricted>
                )}
            />
        );
    }

    if (Components.info) {
        // @ts-ignore
        key = routes[`${ENTITY}_DETAIL`];
        results[`${ENTITY}_DETAIL`] = (
            <Route
                exact
                key={key}
                path={key}
                render={(props) => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.info {...props} />
                    </Restricted>
                )}
            />
        );
    }

    if (Components.v2) {
        // @ts-ignore
        key = routes[`${ENTITY}_V2`];
        results[`${ENTITY}_V2`] = (
            <Route
                exact
                key={key}
                path={key}
                render={(props) => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.v2 {...props} />
                    </Restricted>
                )}
            />
        );
    }
    if (Components.v4) {
        // @ts-ignore
        key = routes[`${ENTITY}_V4`];
        results[`${ENTITY}_V4`] = (
            <Route
                exact
                key={key}
                path={key}
                render={(props) => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.v4 {...props} />
                    </Restricted>
                )}
            />
        );
    }
    if (Components.v3) {
        // @ts-ignore
        key = routes[`${ENTITY}_V3`];
        results[`${ENTITY}_V3`] = (
            <Route
                exact
                key={key}
                path={key}
                render={(props) => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.v3 {...props} />
                    </Restricted>
                )}
            />
        );
    }
    if (Components.target) {
        // @ts-ignore
        key = routes[`${ENTITY}_TARGET`];
        results[`${ENTITY}_TARGET`] = (
            <Route
                exact
                key={key}
                path={key}
                render={(props) => (
                    <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: rule }}>
                        <Components.target {...props} />
                    </Restricted>
                )}
            />
        );
    }
    return Object.values(results);
};
